import React from 'react'
import { GenotypingDto } from 'src/dto/genotyping.dto'
import { formatDate } from 'src/utils'

export const useGenotypingTableHeader = () => {
  const tableHeader = [
    {
      property: 'codigoBarras',
      name: 'COD. BARRAS',
      compoment: (value: GenotypingDto) =>
        value?.codigoBarras || <span style={{ fontStyle: 'italic' }}>insira o codigo de barras</span>,
      textAlign: 'center'
    },
    {
      property: 'serie',
      name: 'SÉRIE',
      compoment: (value: GenotypingDto) => value?.animal?.serie || '-',
      textAlign: 'center'
    },
    {
      property: 'rgd',
      name: 'RGD',
      textAlign: 'center',
      compoment: (value: GenotypingDto) => value?.animal?.rgd || '-'
    },
    {
      property: 'nascimento',
      name: 'NASCIMENTO',
      compoment: (value: GenotypingDto) => formatDate(value?.animal?.dataNascimento || '', false) || '-',
      textAlign: 'center'
    },
    {
      property: 'nome',
      name: 'NOME',
      compoment: (value: GenotypingDto) => value?.animal?.nome || '-',
      textAlign: 'center'
    },
    {
      property: 'sexo',
      name: 'SEXO',
      compoment: (value: GenotypingDto) =>
        value?.animal?.sexo ? (value?.animal?.sexo === 'M' ? 'Macho' : 'Fêmea') : '-',
      textAlign: 'center'
    },
    {
      property: 'cat',
      name: 'CAT',
      compoment: (value: GenotypingDto) => value?.animal?.cat || '-',
      textAlign: 'center'
    },
    {
      property: 'var',
      name: 'VAR',
      compoment: (value: GenotypingDto) => value?.animal?.var || '-',
      textAlign: 'center'
    }
  ]

  return {
    tableHeader
  }
}
